"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.whatYouNeedContextArray = exports.waterInfoValue = exports.waterInfoParams = exports.waterDestinationItem = exports.versionControl = exports.userStatusData = exports.termsString = exports.tempAddSensorPayload = exports.techDipatcherStrings = exports.subHeadingString = exports.storeTileStrings = exports.storeDashboardString = exports.serviceLogType = exports.ownerMobileFirstVisitComponentString = exports.items = exports.imageData = exports.dummySystemData = exports.dispatcherStoreDashboardString = exports.VALIDATION_REGX = exports.USER_STATUS_TYPES = exports.USER_GROUP = exports.OWNER_USER_TYPES = exports.CHALLENGE_NAME = void 0;
var _react = _interopRequireDefault(require("react"));
var _images = _interopRequireDefault(require("../../common_features/assets/images"));
const serviceLogType = exports.serviceLogType = {
  1: "System Added",
  2: "System Updated",
  3: "Water Destination Updated",
  4: "Filter Updated",
  5: "Accessory Added",
  6: "Accessory Updated",
  7: "Water Info Updated",
  8: "Photos Updated"
};
const waterInfoParams = exports.waterInfoParams = {
  'InletTds': "ppm",
  'pretreatmentValue': ' ',
  'InletHardness': "gpg",
  'InletTemp': "F",
  'InletPressure': "psi",
  'pressureDrop': "psid",
  'PermeateTds': "ppm",
  'BlendedTds': "ppm",
  'RejectTds': "ppm",
  'PermeateFlowRate': "ml/min",
  'RejectedFlow': "ml/min",
  'preCharge': "psi",
  'Recovery': "%"
};
const waterInfoValue = exports.waterInfoValue = {
  'InletTds': "Raw Water TDS",
  'pretreatmentValue': 'Water Softener Pretreatment Installed',
  'InletHardness': "Raw Water Hardness",
  'InletTemp': "Raw Water Temperature",
  'InletPressure': "Raw Water Pressure",
  'pressureDrop': "Pre-Filter Pressure Drop",
  'PermeateTds': "Permeate Water TDS",
  'BlendedTds': "Blended Water TDS",
  'RejectTds': "Concentrate TDS",
  'PermeateFlowRate': "Production Flow Rate",
  'RejectedFlow': "Waste Flow Rate",
  'preCharge': "Pre-charge pressure in bladder tank(s) (when empty)",
  'Recovery': "Recovery"
};
const userStatusData = exports.userStatusData = {
  modalHeaderText: "User Status Data",
  active: "-  User onboarded successfully.",
  Invitation_Pending: "- Invitation mail sent to the user to onboard themselves within 24 hours.",
  Invitation_Expired: "- Invitation has been expired. Re-send by clicking on resend button.",
  In_Process: "- The user started the sign-up process but has not completed it.",
  Email_Updated: "- Invitation is not yet verified by the user."
};
const VALIDATION_REGX = exports.VALIDATION_REGX = {
  email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([\w-]+\.)+[\w-]{2,4}$/,
  specialCharacter: /[-\/\\^$*+?.()|[\]{}"!@#%&,><':;_~=`]/,
  hasEmoji: /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/
};
const CHALLENGE_NAME = exports.CHALLENGE_NAME = {
  SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  TOTP_SETUP: 'TOTP_SETUP',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD'
};
const USER_STATUS_TYPES = exports.USER_STATUS_TYPES = {
  1: "Active",
  2: "Invitation Pending",
  3: "Invitation Expired",
  4: "In Process",
  5: "Email Verification Pending"
};
const ownerMobileFirstVisitComponentString = exports.ownerMobileFirstVisitComponentString = {
  SUB_CONTENT: "No Store Added",
  MAIN_CONTENT: "Click on Add Store to add a store"
};
const subHeadingString = exports.subHeadingString = {
  TOTAL_STORES: "Total Stores"
};
const dispatcherStoreDashboardString = exports.dispatcherStoreDashboardString = {
  MAIN_CONTENT: /*#__PURE__*/_react.default.createElement("div", {
    className: "disStore-content"
  }, "This is where you will see the\xA0", /*#__PURE__*/_react.default.createElement("span", {
    className: "disStore-bold"
  }, "Stores"), " in which you will service. These will appear here automatically after being assigned by Pentair and your account administrator."),
  BOTTOM_CONTENT: /*#__PURE__*/_react.default.createElement("div", {
    className: "disStore-bottomContent"
  }, "Learn more about  ", /*#__PURE__*/_react.default.createElement("img", {
    src: _images.default.smallPentairLogo.default,
    alt: "right"
  }), " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.pentair.com/en-us/commercial-filtration/brands/everpure.html",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "content-colorbold"
  }, "Everpure"), " here.")
};
const storeDashboardString = exports.storeDashboardString = {
  MAIN_HEADING: "Welcome to your Store Dashboard!",
  MAIN_CONTENT: /*#__PURE__*/_react.default.createElement("div", {
    className: "storeDashboard-content"
  }, "This is where you will see your\xA0", /*#__PURE__*/_react.default.createElement("span", {
    className: "content-bold"
  }, "Everpure Filter System."), " The details will be added to this view automatically when your Service Professional adds it."),
  BOTTOM_CONTENT: /*#__PURE__*/_react.default.createElement("div", {
    className: "storeDash-bottom-content"
  }, "Learn more about  ", /*#__PURE__*/_react.default.createElement("img", {
    src: _images.default.smallPentairLogo.default,
    alt: "right"
  }), " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.pentair.com/en-us/commercial-filtration/brands/everpure.html",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "content-colorbold"
  }, "Everpure"), " here."),
  NAV_HEADING_CONTENT: "Home Dashboard",
  NAV_HEADING_CONTENT_WEB_VIEW: "Manage Stores"
};
const termsString = exports.termsString = {
  MAIN_CONTENT: /*#__PURE__*/_react.default.createElement("div", null, "Allow Pentair to send automated text messages about upcoming appointments, promotions, products and services relevant to you. Receiving texts is optional, and you can text \u201Cstop\u201D to opt-out. By opting in, you are agreeing to our ", /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: "https://www.pentair.com/en-us/legal/terms-of-use/sc-app-terms-and-conditions-en-us.html",
    rel: "noopener noreferrer",
    className: "content-colorbold"
  }, "SMS Terms & Conditions"), " and our ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.pentair.com/en-us/legal/privacy-notice.html",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "content-colorbold"
  }, "Privacy Notice"), ". Message frequency may vary per user. You will receive a text message from Pentair, please reply YES to receive texts.")
};
const techDipatcherStrings = exports.techDipatcherStrings = {
  SUB_HEADING: "Add your first system!",
  SUB_CONTENT: "Let's set up this store's equipment in the app.",
  BOTTOM_CONTENT: "What do I need to know?",
  NAV_HEADING_CONTENT: "Home Dashboard",
  NAV_HEADING_CONTENT_WEB_VIEW: "Manage Stores"
};
const storeTileStrings = exports.storeTileStrings = {
  SUCCESS_LABEL: "Everything's OK!"
};
const USER_GROUP = exports.USER_GROUP = {
  OWNER: "pentair_org_owner_group",
  DISPATCHER: "pentair_sp_dispatcher_group",
  MANAGER: "pentair_store_manager_group",
  TECHNICIAN: "pentair_sp_technician_group"
};
const OWNER_USER_TYPES = exports.OWNER_USER_TYPES = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  TWM: 3,
  OWNER: 4,
  DISPATCHER: 5,
  MANAGER: 6,
  TECHNICIAN: 7
};
const whatYouNeedContextArray = exports.whatYouNeedContextArray = ["You'll add your system", "You'll choose your accessory (or accessories) if needed", "You'll choose your filter", "Tell us the water destination", "System Added You'll see your system on this dashboard"];
const waterDestinationItem = exports.waterDestinationItem = {
  Steam: _images.default.steamIcon.default,
  Fountain: _images.default.fountaineIcon.default,
  Ice: _images.default.iceIcon.default,
  Hot: _images.default.hotIcon.default
};
const items = exports.items = [{
  name: "Steam",
  image: _images.default.steamIcon.default
}, {
  name: "Fountain",
  image: _images.default.fountaineIcon.default
}, {
  name: "Ice",
  image: _images.default.iceIcon.default
}, {
  name: "Hot",
  image: _images.default.hotIcon.default
}];
const imageData = exports.imageData = [_images.default.streamSystem.default, _images.default.iceSystem.default, _images.default.fountainSystem.default, _images.default.hotSystem.default];
const tempAddSensorPayload = exports.tempAddSensorPayload = [{
  refAppType: "Replacement Part",
  refAppPartNumber: "EV9627-16",
  refAppName: "Pre-Filter",
  refAppLife: 12,
  selectedRefAppLife: 12,
  refAppImageUrl: "https://mocksystems.s3.amazonaws.com/filter.png",
  refAppModelNumber: "FS-BW"
}, {
  refAppType: "Replacement Part",
  refAppPartNumber: "#12345678",
  refAppName: "RO Membrane",
  refAppLife: 24,
  refAppImageUrl: "https://mocksystems.s3.amazonaws.com/filter.png",
  refAppModelNumber: "MR-600-F"
}, {
  refAppType: "Replacement Part",
  refAppPartNumber: "#12345678",
  refAppName: "Pre-Filter",
  refAppLife: 12,
  selectedRefAppLife: 12,
  refAppImageUrl: "https://mocksystems.s3.amazonaws.com/filter.png",
  refAppModelNumber: "MC2"
}, {
  refAppType: "Accessory",
  refAppPartNumber: "#12345678",
  refAppName: "Storage Tank",
  refAppImageUrl: "https://mocksystems.s3.amazonaws.com/tank.png",
  refAppModelNumber: "RO Mate 60 Slimline"
}];
const dummySystemData = exports.dummySystemData = {
  system_id: 'EV997007',
  system_inactive_status_flag: 'No',
  short_description: '100 GPD RO System improves equipment life and performance by removing at least 90 25 2B of all dissolved solids that cause scale buildup.',
  'Model Number': 'MRS-100 RO Systems',
  reference_ids: [{
    reference_id: '34679',
    reference_inactive_status_flag: 'No',
    reference_type: 'Accessory',
    reference_application: 'RO Storage Tank',
    reference_application_category: 'Primary',
    short_description: '15 gallon hydro-pneumatic storage tanks for storing and dispensing Reverse Osmosis  28RO 29 2Fhigh purity water.',
    'Model Number': 'RO15',
    asset: {
      sku_id: '34679',
      url: 'url testggggggg'
    }
  }, {
    reference_id: '34681',
    reference_inactive_status_flag: 'No',
    reference_type: 'Accessory',
    reference_application: 'RO Storage Tank',
    reference_application_category: 'Alternate',
    short_description: '60 gallon hydro-pneumatic storage tanks for storing and dispensing Reverse Osmosis  28RO 29 2Fhigh purity water.',
    'Model Number': 'RO30',
    asset: {
      sku_id: '34681'
    }
  }, {
    reference_id: '34685',
    reference_inactive_status_flag: 'No',
    reference_type: 'Accessory',
    reference_application: 'RO Storage Tank',
    reference_application_category: 'Alternate',
    short_description: '120 gallon hydro-pneumatic storage tanks for storing and dispensing Reverse Osmosis  28RO 29 2Fhigh purity water.',
    'Model Number': 'RO120'
  }, {
    reference_id: '34680',
    reference_inactive_status_flag: 'No',
    reference_type: 'Accessory',
    reference_application: 'RO Storage Tank',
    reference_application_category: 'Alternate',
    short_description: '20 gallon hydro-pneumatic storage tanks for storing and dispensing Reverse Osmosis  28RO 29 2Fhigh purity water.',
    spec_name: 'Model Number',
    'Model Number': 'RO20',
    asset: {
      sku_id: '34680'
    }
  }, {
    reference_id: '34684',
    reference_inactive_status_flag: 'No',
    reference_type: 'Accessory',
    reference_application: 'RO Storage Tank',
    reference_application_category: 'Alternate',
    short_description: '80 gallon hydro-pneumatic storage tanks for storing and dispensing Reverse Osmosis  28RO 29 2Fhigh purity water.',
    'Model Number': 'RO80'
  }, {
    reference_id: '34682',
    reference_inactive_status_flag: 'No',
    reference_type: 'Accessory',
    reference_application: 'RO Storage Tank',
    reference_application_category: 'Alternate',
    short_description: '60 gallon hydro-pneumatic storage tanks for storing and dispensing Reverse Osmosis  28RO 2Fhigh purity water.',
    'Model Number': 'RO40',
    asset: {
      sku_id: '34682'
    }
  }, {
    reference_id: '34683',
    reference_inactive_status_flag: 'No',
    reference_type: 'Accessory',
    reference_application: 'RO Storage Tank',
    reference_application_category: 'Alternate',
    short_description: '60 gallon hydro-pneumatic storage tanks for storing and dispensing Reverse Osmosis  28RO 29 2Fhigh purity water.',
    'Model Number': 'RO60',
    asset: {
      sku_id: '34683'
    }
  }, {
    reference_id: 'EV960741',
    reference_inactive_status_flag: 'No',
    reference_type: 'Replacement Part',
    reference_application: 'Carbon Prefilter',
    reference_application_category: 'Alternate',
    sequence: 1,
    short_description: 'Prefilter offers chlorine taste and odor reduction for RO membranes which are sensitive to chlorine.',
    'Estimated Filter Life (months)': '12',
    'Model Number': '6TO-BW',
    'SKU Label Color': 'A4343A'
  }, {
    reference_id: 'EV926211',
    reference_inactive_status_flag: 'No',
    reference_type: 'Replacement Part',
    sequence: 2,
    reference_application: 'RO Membrane',
    reference_application_category: 'Primary',
    short_description: 'Replacement RO module for all MRS-100 systems',
    'Estimated Filter Life (months)': '24',
    'Model Number': 'MR-100',
    asset: {
      sku_id: 'EV926211',
      url: 'https://www.pentair.com/content/dam/extranet/web/nam/everpure/commercial/images/product-images/EV962711_810x540.jpg',
      tag_id: 'image1',
      asset_desc: '01:<MR-100>'
    }
  }],
  asset: {
    sku_id: 'EV997007',
    url: 'https://www.pentair.com/content/dam/extranet/web/nam/everpure/commercial/images/product-images/EV997007_810x540.jpg',
    tag_id: 'image1 test Ggggggg',
    asset_desc: '01:<MRS-100>'
  }
};
const versionControl = exports.versionControl = {
  version: "1.0.0",
  buildNumber: "1"
};